import { axiosInstance } from '@/utils/lib/axios';
import { useMutation, useQuery } from '@tanstack/react-query';
import { Dialog } from 'alurkerja-ui';
import { FieldValues } from 'react-hook-form';
import { AxiosError } from 'axios';
import { env } from '@/utils/constants/env';

interface IUser {
  id: string;
  email: string;
  name: string;
}

interface IUserProfile extends IUser {
  odoo_id?: string;
  manager_id?: string;
  approver?: {
    user_id: string;
    manager_id: string;
    manager_approver: IUser;
  };
  manager?: IUser;
  role?: {
    id: string;
    name: string;
  };
  tenant_role?: string;
  username: string;
}

export const UserService = {
  useGetProfile: () =>
    useQuery<IUserProfile>({
      queryKey: ['profile'],
      queryFn: async () => {
        const response = await axiosInstance.get(env.apiTasklistBaseUrl + '/api/v1/authentication/profile');

        return response.data.data;
      },
    }),

  useUpdate: () =>
    useMutation({
      mutationFn: ({ id, payload }: { id: string; payload: FieldValues }) => {
        const url = `/auth/v1/crud/user/${id}`;

        return axiosInstance.put(url, payload, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      },
      onSuccess: () => {
        Dialog.success({
          title: 'Berhasil!',
          description: 'Berhasil mengubah data user',
        });
      },
      onError(error: AxiosError<{ [x: string]: string }>) {
        if (error.response?.data.message) {
          Dialog.error({
            title: 'Gagal Menyimpan',
            description: `Periksa kembali data yang diinputkan, tidak boleh kosong`,
          });
        } else {
          Dialog.error({
            title: 'Gagal Menyimpan',
            description: `Server Internal Error`,
          });
        }
      },
    }),
};
